import { render, staticRenderFns } from "./MainMenuAppStoreButton.vue?vue&type=template&id=6f1c27f9&scoped=true&"
import script from "./MainMenuAppStoreButton.vue?vue&type=script&lang=js&"
export * from "./MainMenuAppStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuAppStoreButton.vue?vue&type=style&index=0&id=6f1c27f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c27f9",
  null
  
)

export default component.exports